export default __webpack_public_path__ + "static/media/SELLO_SEMILLAS_CERTIFICADAS.4f05ad44.png";